import { defineMessages } from 'react-intl';

export const loginPageMessages = defineMessages({
  title: {
    id: 'login.title',
    defaultMessage: 'Process Lifecycle Navigator',
    description: 'Login page title',
  },
  button: {
    id: 'login.button',
    defaultMessage: 'Login',
    description: 'Login button',
  },
  requestAccess: {
    id: 'login.requestAccess',
    defaultMessage: 'Request access',
    description: 'Request Access button',
  },
  changelog: {
    id: 'login.changelog',
    defaultMessage: 'CHANGELOG',
    description: 'Changelog button',
  },
  changelogError: {
    id: 'login.changelogError',
    defaultMessage: 'Error while loading the changelog.',
    description: 'Changelog error',
  },
  servicePortal: {
    id: 'login.servicePortal',
    defaultMessage: 'myIT Service Portal',
    description: 'Service Portal button',
  },
  dirXManual: {
    id: 'login.dirXManual',
    defaultMessage: 'DirX Manual',
    description: 'DirX Manual button',
  },
  onboarding: {
    id: 'login.onboarding',
    defaultMessage: 'Onboarding',
    description: 'Onboarding button',
  },
  or: {
    id: 'login.or',
    defaultMessage: 'or',
    description: 'or',
  },
});
